import Layout from "layouts/Layout";
import Auth from "modules/Auth/Middleware/Auth";
import GeneralSettingsContent from "modules/GeneralSettings";
import React from "react";
import { setTitle } from "utilities/helper/setTitle";

const GeneralSettingsPage: React.FC = () => {
  setTitle("General Setting");
  return (
    <Auth>
      <Layout>
        <GeneralSettingsContent />
      </Layout>
    </Auth>
  );
};

export default GeneralSettingsPage;
